import React, { useEffect, useRef } from "react";
import {
  DownloadButton,
  TopHeading,
  Wrapper,
} from "../../../common/index.style";
import TransactionDataTableAG from "../../../components/table/TransactionDataTableAG";
import { DataContent } from "../publishers/index.style";
import { useDispatch, useSelector } from "react-redux";
import {
  getTransactionsPage,
  downloadAllTransactions,
  clearDownloadData,
} from "../../../redux/transactionSlice";
import { CSVLink } from "react-csv";
import { csvTransactionData } from "../../../utils/helper";
import { Row, Col } from "antd";

const Transactions = () => {
  const dispatch = useDispatch();
  const csvLinkRef = useRef(null);

  const { transactions, total, currentPage, loading, downloadLoading, downloadData } =
    useSelector((state) => state.transaction);

  useEffect(() => {
    dispatch(getTransactionsPage(0));
  }, []);

  // Trigger the hidden CSV link as soon as download data is ready
  useEffect(() => {
    if (downloadData && csvLinkRef.current) {
      csvLinkRef.current.link.click();
      dispatch(clearDownloadData());
    }
  }, [downloadData]);

  const handlePageChange = (page) => {
    dispatch(getTransactionsPage(page));
  };

  const handleDownload = () => {
    dispatch(downloadAllTransactions());
  };

  const csvData = csvTransactionData(downloadData ?? []);

  return (
    <Wrapper>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <TopHeading style={{ margin: 0 }}>Transactions</TopHeading>
        </Col>
        <Col>
          <DownloadButton onClick={handleDownload} disabled={downloadLoading}>
            {downloadLoading ? "Preparing..." : "Download"}
          </DownloadButton>
          {/* Hidden CSVLink — triggered programmatically once data is ready */}
          <CSVLink
            ref={csvLinkRef}
            filename="transactions"
            data={csvData}
            style={{ display: "none" }}
          />
        </Col>
      </Row>
      <DataContent>
        <TransactionDataTableAG
          loading={loading}
          transactions={transactions}
          total={total}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </DataContent>
    </Wrapper>
  );
};

export default Transactions;
